<template>
	<app>
		<flow-node :node="nodeList" :current="currentNode" :reject="rejectNode"></flow-node>
		<c-detail>
			<c-detail-item v-if="detailInfo.qs_state < 3" label="距离签约截止日仅剩">
				<countdown :date="detailInfo.qy_last_date" @end="updateDetail"></countdown>
			</c-detail-item>
			<c-detail-item label="合同标题">
				{{detailInfo.name}}
			</c-detail-item>
			<c-detail-item label="合同编号">
				{{detailInfo.code}}
			</c-detail-item>
			<c-detail-item label="合同状态">
				<span v-if="detailInfo.qs_state" :style="{'color': contractState[detailInfo.qs_state].color}">{{contractState[detailInfo.qs_state].name}}</span>
			</c-detail-item>
			<c-detail-item label="所属项目名称">
				{{detailInfo.project_name}}
			</c-detail-item>
			<c-detail-item label="甲方">
				{{detailInfo.yzdw_name}}
			</c-detail-item>
			<c-detail-item label="乙方">
				{{detailInfo.zbqy_name}}
			</c-detail-item>
			<c-detail-item label="签约截止日">
				{{detailInfo.qy_last_date}}
			</c-detail-item>
			<c-detail-item label="乙方经办人">
				{{detailInfo.jbr_name}}<span v-if="detailInfo.jbr_phone">（{{detailInfo.jbr_phone}}）</span>
			</c-detail-item>
			<c-detail-item label="创建时间">
				{{detailInfo.create_date}}
			</c-detail-item>
			<c-detail-item label="乙方电子邮箱">
				{{detailInfo.zb_money}}
			</c-detail-item>
			<!-- <c-detail-item label="合同源文件">
				<c-file :src="detailInfo.file_path"></c-file>
			</c-detail-item> -->
			<c-detail-item label="(业主)签署后文件">
				<c-file :src="detailInfo.yz_qs_file_path"></c-file>
			</c-detail-item>
			<c-detail-item label="(企业)签署后文件">
				<c-upload-file v-if="detailInfo.qs_state == 2" v-model="detailInfo.qy_qs_file_path" button="上传已盖章合同"  word="请上传签署好的合同文件" type="pdf">
					<span slot="word" style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
				</c-upload-file>
				<c-file v-else :src="detailInfo.qy_qs_file_path"></c-file>
			</c-detail-item>
		</c-detail>
		
		<c-title>签署流程</c-title>
		<c-detail>
			<timeline slot="custom" :data="timeline"></timeline>
		</c-detail>
		
		<button-group slot="foot">
			<div v-if="signButton" class="flex-center">
				<c-button color="green" @click="signHt">确认签署完成</c-button>
				<c-button color="red" @click="$refs.approve.reject({title: '拒绝签署'})">拒绝签约</c-button>
			</div>
		</button-group>
		
		<approve ref="approve" @resolve="approveHandle"></approve>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import countdown from '@/components/unit/countdown.vue'
	import timeline from '@/components/module/timeline.vue'
	import approve from '@/components/module/approve.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			flowNode,
			countdown,
			timeline,
			approve
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				nodeList: [{
					name: '创建合同'
				}, {
					name: '待业主签署'
				}, {
					name: '待企业签署'
				}, {
					name: '合同签署完结'
				}],
				detailInfo: {},
				timeline: ''
			}
		},
		
		computed: {
			...mapGetters(['power', 'contractState']),
			
			currentNode() {
				return (this.detailInfo.qs_state || 1) + 1;
			},
			
			rejectNode() {
				return this.detailInfo.qs_state == 4 ? 3 : 0;
			},
			
			signButton() {
				return this.detailInfo.qs_state == 2 && this.power('7');
			}
		},
		
		mounted() {
			this.updateDetail();
		},
		
		methods: {
			updateDetail() {
				this.request({
					url: '/project/ht/detail',
					data: {
						ht_id: this.id
					},
					success: data => {
						this.detailInfo = data.htInfo;
						this.timeline = Array.from(data.logList, item => {
							return {
								date: item.create_date,
								content: `[${item.create_user_name}] ${item.remark}`
							}
						});
					}
				});
			},
			//电子签章签署（在线签署）
			signHandle() {
				this.request({
					url: '/signature/fr/url',
					data: {
						businessType: 1,
						businessId: this.detailInfo.id
					},
					loading: true,
					success: data => {
						this.navigateTo(data, 'open');
						this.$confirm({
							text: '等待签署中',
							message: '签署完成请点击已完成签署按钮',
							buttonName: '已完成签署',
							resolve: () => {
								this.updateDetail();
							}
						});
					}
				});
			},
			
			//签署合同（离线签署）
			signHt(){
				if(!this.detailInfo.qy_qs_file_path){
					this.$message({
						text: '请上传签署好的合同文件'
					});
					return;
				}
				
				this.request({
					url: '/project/ht/sign',
					data: {
						ht_id: this.id,
						qy_qs_file_path: this.detailInfo.qy_qs_file_path
					},
					loading: true,
					success: () => {
						this.$message({
							text: '合同签署成功'
						});
						this.updateDetail();
					}
				});
			},
			
			//拒签合同
			approveHandle(state, remark, stop, next) {
				stop();
				this.request({
					url: '/project/ht/reject',
					data: {
						ht_id: this.id,
						reject_remark: remark
					},
					loading: true,
					success: data => {
						next();
						this.$message({
							text: '拒签成功'
						});
						this.updateDetail();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
